<template>
    <div class="mailp" :class="{mailpActive: mailPActive}">
        <div class="mailp-close cursor-pointer" @click="CloseMailP()">
            <img
                class="mailp-close-icon"
                src="../assets/img/svg/close.svg"
                alt="cancel-img"
                />
        </div>
        <router-link to="#contact">
            <div @click="Click()" class="cursor-pointer">
                <div class="display-flex">
                    <div class="mailp-text-container">
                        <div class="mailp-text">
                            Get in touch!
                        </div>
                    </div>
                    <div class="mailp-icon-container">
                        <img
                            class="mailp-mail-icon"
                            src="../assets/img/svg/mail.svg"
                            alt="cancel-img"
                        />
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      constructionActive: false,
    }
  },
  mounted() {
      const t = this.$store
      setTimeout(() => {
          console.log('set active')
          t.dispatch('ActionSetMailPActive', true)
      }, 4000)
  },
  computed: {
    mailPActive() {
      return this.$store.getters.GetMailPActive
    },
  },
  methods: {
    Click() {
        this.CloseMailP()
    },
    CloseMailP() {
        this.$store.dispatch('ActionSetMailPActive', false)
    }
  },
};
</script>

<style lang="css">
.mailp-close-icon {
    margin-left: 4px;
    margin-top: -5px;
    width: 19px;
    height: 19px;
}
.mailp-mail-icon {
    width: 54px;
    height: 27px;
    margin-top: 10px;
}
.mailp {
    position: fixed;
    bottom: 38px;
    right: -200px;
    z-index: 1000;
    transition: all .5s ease;
}

@media screen and (max-width: 767px) {
    .mailp.mailpActive {
        right: 28px !important;
        bottom: 20px !important;
    }
}
.mailp.mailpActive {
    right: 45px;
}
.mailp-close {
    margin-top: -20px;
    position: absolute;
    right: -10px;
    top: -5px;
    background: white;
    border-radius: 100%;
    box-shadow: 0px 3px 10px #00000033;
    /* padding-left: 25px;
    padding-right: 25px; */
    width: 26px;
    height: 26px;
}
.mailp-text-container {
    margin-right: 10px;
    background: #ffffff;
    border-radius: 7px;
    box-shadow: 0px 4px 10px #00000033;
    height: 29px;
    margin-top: 11px;
    width: 0px;
    padding-right: 0px;
    padding-left: 0px;
    transition: all .5s ease;
    transition-delay: .8s;
    overflow: hidden;
}
.mailp-icon-container {
    background: #ffffff;
    border-radius: 100px;
    width: 50px;
    height: 50px;
    box-shadow: 0px 4px 10px #00000033;
}
.mailp-text {
    width: 200px;
    color: #222;
    text-decoration: none;
    display: inline-block;
}

.mailpActive .mailp-text-container {
    width: 107px;
    padding-left: 7px;
    padding-right: 7px;
}

</style>
